export const STATUS_CODES = {
  INVALID_TOKEN: 300,
  SUCCESS: 200,

};
